import { Component, Input } from '@angular/core';
import { OmpHeadingSize } from '../../../_models';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-text-box-settings',
  templateUrl: './text-box-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpTextBoxSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  @Input() pageBackground = '';

  get needsText(): boolean {
    return this.isEmpty('section_heading') && this.isEmpty('description');
  }

  get previewBackground(): string {
    let background = this.pageBackground;
    if (this.data && this.data.display_inside_card && this.data.background_color) {
      background = this.data.background_color;
    }
    return background;
  }

}
